import React from 'react';
import { Shield, Users, Zap, Building2 } from 'lucide-react';

const items = [
  { icon: Shield, label: 'Strict community isolation' },
  { icon: Users, label: 'Residents · Management · Guards' },
  { icon: Zap, label: 'Real-time push notifications' },
  { icon: Building2, label: 'Multi-tenant SaaS' },
];

export const TrustStrip = () => (
  <section
    className="py-14 bg-white border-y border-slate-100"
    data-testid="trust-strip"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <p
        className="text-base md:text-lg tracking-wide uppercase text-slate-500 font-semibold text-center"
        style={{ fontFamily: 'Outfit, sans-serif' }}
      >
        Built for residential communities of every size
      </p>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map(({ icon: Icon, label }) => (
          <div
            key={label}
            className="flex items-center gap-3 px-4 py-3 rounded-lg bg-[#0B1120] border border-slate-800 shadow-sm"
            data-testid={`trust-item-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          >
            <div className="w-9 h-9 rounded-md bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-[#14D4C6]" />
            </div>
            <span
              className="text-sm font-medium text-slate-200"
              style={{ fontFamily: 'Work Sans, sans-serif' }}
            >
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
